import { render, staticRenderFns } from "./InlineEditable.vue?vue&type=template&id=63bf3534&scoped=true&"
import script from "./InlineEditable.vue?vue&type=script&lang=ts&"
export * from "./InlineEditable.vue?vue&type=script&lang=ts&"
import style0 from "./InlineEditable.vue?vue&type=style&index=0&id=63bf3534&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bf3534",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VTextField})
